import View from 'client/components/common/BuildingBlocks/FloatAbove/FloatAbove';
import model from 'client/components/common/BuildingBlocks/FloatAbove/model';

export const FLOAT_ABOVE = () => ({
	view: View,
	get model() {
		return model();
	},
});
